export enum TypeDocumentEnums {
  nit = 1,
  cedula = 2,
  extranjeria = 3,
  ppt = 4,
  ti = 5
}